import React from 'react';
import { Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';

const dataOptions = ['Population','GDP'];
const genderOptions = ['All', 'Male', 'Female'];
const ageOptions = ['All', '5-14', '15-24', '25-34', '35-54', '55-74', '75+'];


const list_choice = { '2':"GDP", '10':"population", '11':"malePopulation", '12':"femalePopulation", 
'000':"totalRate", "010":"maleRate","020": "femaleRate","001":"5-14","002":"15-24",'003':"25-34",
"004":"35-54",'005':"55-74",'006':"75+",'011':"male_5-14",'012':"male_15-24",
'013':"male_25-34",'014':"male_35-54",'015':"male_55-74",'016':"male_75+",
'021':"female_5-14",'022':"female_15-24",'023':"female_25-34",'024':"female_35-54",'025':"female_55-74",
'026':"female_75+"}

export default class Selection2 extends React.Component {
    constructor(){
		super();
		this.state = {
			selectedDataType: 'Suicide Rate',
			selectedGender: 'All',
			selectedAge: 'All',
        };
    }
		
		calculateReturn2 = (selectedGender) => {
			var str = ''
				var c = genderOptions.indexOf(selectedGender)
				var a = ageOptions.indexOf(this.state.selectedAge)
				str = list_choice['0'+c.toString()+a.toString()]
			console.log('updating',str)
			this.props.updateData(str);
		}

		calculateReturn3 = (selectedAge) => {
			var str = ''
				var c = genderOptions.indexOf(this.state.selectedGender)
				var a = ageOptions.indexOf(selectedAge)
				str = list_choice['0'+c.toString()+a.toString()]
			console.log('updating',str)
			this.props.updateData(str);
		}

	handleGenderSelect = (event) => {
		const selectedGender = event.target.value;
		this.setState({ selectedGender });
		this.calculateReturn2(selectedGender);
	}

	handleAgeSelect = (event) => {
		const selectedAge = event.target.value;
		this.setState({ selectedAge });
		this.calculateReturn3(selectedAge);

    }


    render() {
		let genderSelect = genderOptions.map((gender) => {
			return (
				<FormGroup check>
						<Label check>
							<Input type="radio" name="gender" onClick={this.handleGenderSelect} value={gender} defaultChecked={gender===this.state.selectedGender} />{' '}
							{gender}
						</Label>
					</FormGroup>
			);
		});
		const ageSelect = ageOptions.map((age) => {
			return (
				<FormGroup check>
						<Label check>
							<Input type="radio" name="age" onClick={this.handleAgeSelect} value={age} defaultChecked={age===this.state.selectedAge} />{' '}
							{age}
						</Label>
					</FormGroup>
			);
		});
		return (
            <div className="selection" >
                <h3>Gender Selection</h3>
                {genderSelect}
                <br />
                <h3>Age Selection</h3>
                {ageSelect}
			</div>
		);
	}




}